import css from 'styled-jsx/css';

export const staticStyles = css`
  .PaymentErrors {
    min-width: 0;
    width: 100%;
    overflow-wrap: anywhere;
    font-size: 14px;
    line-height: 1.5;
    text-align: start;
  }

  .PaymentErrors .PaymentErrors__title {
    margin: 0 0 16px;
    padding: 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
  }

  .PaymentErrors .PaymentErrors__category {
    margin-bottom: 16px;
    padding: 16px;
    border: 1px solid;
    border-radius: 4px;
  }

  .PaymentErrors .PaymentErrors__summary {
    display: list-item;
    margin: 0;
    padding: 0;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
  }

  .PaymentErrors .PaymentErrors__list {
    display: block;
    margin: 16px 0 0;
    padding: 0;
    list-style: none;
  }

  .PaymentErrors .PaymentErrors__item {
    display: block;
    min-width: 0;
    margin: 0;
    padding: 0;
    font-size: 14px;
    line-height: 1.5;
  }

  .PaymentErrors .PaymentErrors__item + .PaymentErrors__item {
    margin-top: 16px;
  }

  .PaymentErrors .PaymentErrors__timestamp {
    display: block;
    margin: 0;
    padding: 0;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.5;
  }

  .PaymentErrors .PaymentErrors__message {
    display: block;
    margin: 8px 0 0;
    padding: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    white-space: pre-wrap;
  }
`;

export function getDynamicStyles({ colors }) {
  return css`
    .PaymentErrors,
    .PaymentErrors .PaymentErrors__message {
      color: ${colors.black.hex};
    }

    .PaymentErrors .PaymentErrors__category {
      border-color: ${colors.lightGray.hex};
    }

    .PaymentErrors .PaymentErrors__title,
    .PaymentErrors .PaymentErrors__summary,
    .PaymentErrors .PaymentErrors__timestamp {
      color: ${colors.gray.hex};
    }
  `;
}
